module.exports = __webpack_public_path__ + "assets/img/thumb-Gourmet-Basket-eBook.dbb2a56f.png";